import { BicyclePennyFarthingIcon } from './BicyclePennyFarthingIcon';

/**
 * author: Colton Wiscombe
 * id A7A362D7-385E-4026-A43F-BBF13E8D4B37
 * name bicycle-penny-farthing
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bicycle-penny-farthing.svg
 * tags
 * - Transportation + Other 
 * - Sport 
 */
export const BicycleHighWheelIcon = BicyclePennyFarthingIcon;
export default BicycleHighWheelIcon